import { ReactElement, ReactNode } from 'react';

import { PaloOverflowMenu } from './palo-overflow-menu';

export interface PaloRecordAction {
    label: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    /** Drawn in the critical colour — for what cannot be undone. */
    danger?: boolean;
}

export interface PaloRecordMenuProps {
    actions: PaloRecordAction[];
    /** Named for a screen reader; the trigger itself is only three dots. */
    label: string;
}

/**
 * Everything a record can have done to it besides being saved.
 *
 * Locking, hiding and deleting used to sit as switches and buttons beside
 * "Speichern", so deleting a whole member was one slip away from saving it
 * (#2194, A-1). Behind a menu they still take two clicks to reach, but never
 * the one meant for something else.
 *
 * It is the overflow menu every other mask uses, under the name the master
 * data screens know it by — it had its own copy, and the two drew their dots
 * in different directions at the same spot in the top bar (06.10.2026).
 */
export const PaloRecordMenu = ({ actions, label }: PaloRecordMenuProps): ReactElement | null => (
    <PaloOverflowMenu actions={actions} label={label} />
);
